import { useGenerateResult, useQrSvgContent } from "@/states/common.state";
import { Data } from "@/types/all.types";
import { IResponseFromQrApi } from "@/types/response.types";

export function useHandleGenerateResult() {
  const { setGenerateResult } = useGenerateResult.getState();
  const { setSvgContent } = useQrSvgContent.getState();

  const handleGenerateResult = (val: null | Data<IResponseFromQrApi<Record<string, any>>>) => {
    setGenerateResult(val);
    const svgContent = val?.data?.svgContent || null;
    setSvgContent(svgContent?.toString());
  };

  return { handleGenerateResult };
}
